import {IAuthClient} from "../protocols/auth-client";
import {ICacheStorage} from "../protocols/cache";

const AUTH_TOKEN_KEY = "authToken";

export class AuthDatasource implements IAuthClient {
  constructor(private cacheStorage: ICacheStorage) {}

  async getToken() {
    return this.cacheStorage.get(AUTH_TOKEN_KEY)
  }

  setToken(token: string) {
    this.cacheStorage.set(AUTH_TOKEN_KEY, token)
  }
}